import type { SVGProps } from 'react';
export const SvgLikeFill = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={21}
		fill="none"
		viewBox="0 0 20 21"
		{...props}
	>
		<path
			fill="#6E9900"
			stroke="#101010"
			strokeMiterlimit={10}
			d="m6.233 15.792 2.584 2c.333.333 1.083.5 1.583.5h3.167c1 0 2.083-.75 2.333-1.75l2-6.083c.417-1.167-.333-2.167-1.583-2.167h-3.334c-.5 0-.916-.417-.833-1l.417-2.667c.166-.75-.334-1.583-1.084-1.833-.666-.25-1.5.083-1.833.583L6.233 8.46"
		/>
		<path
			fill="#6E9900"
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M1.983 15.792V7.625c0-1.166.5-1.583 1.667-1.583h.833c1.167 0 1.667.417 1.667 1.583v8.167c0 1.167-.5 1.583-1.667 1.583H3.65c-1.167 0-1.667-.416-1.667-1.583"
		/>
	</svg>
);
